export default "__VITE_ASSET__a0eb1aad__"